import type Backbone from 'backbone';
import _ from 'underscore';

import user from 'js/lib/user';

import handleResponse from 'bundles/naptime/handleResponse';
import submissionSummariesData from 'bundles/programming/data/submissionSummaries';
import SubmissionHistory from 'bundles/programming/models/submissionHistory';
import SubmissionSummary from 'bundles/programming/models/submissionSummary';

export const getSubmissionSummaries = async ({
  itemId,
  itemTypeName,
  courseId,
  courseSlug,
  userId,
}: {
  itemId: string;
  itemTypeName: string;
  courseId: string;
  courseSlug: string;
  userId: number;
}): Promise<Backbone.Collection> => {
  if (!user.isAuthenticatedUser()) {
    return Promise.resolve(new SubmissionHistory([]));
  } else {
    return submissionSummariesData({ itemId, itemTypeName, courseId, courseSlug, userId })
      .then(handleResponse)
      .then(function (naptimeResponse: $TSFixMe) {
        const submissionSummaries = _(naptimeResponse.elements).map(function (summary) {
          return new SubmissionSummary(
            _({}).extend(summary, summary.submissionSummary, {
              partEvaluations: summary.submissionSummary.parts,
            }),
            { parse: true }
          );
        });
        return new SubmissionHistory(submissionSummaries);
      });
  }
};

export default getSubmissionSummaries;
